module.exports = __webpack_public_path__ + "img/piece-complete-6.10c512dd.svg";